"use client";

import Link from "next/link";

export default function TrialBanner({
  externalBilling,
  trialExpiresAt,
  tier,
  billingHref,
}: {
  externalBilling: boolean;
  trialExpiresAt: string | null | undefined;
  tier: string | undefined;
  billingHref: string;
}) {
  if (externalBilling || !trialExpiresAt) return null;

  const daysLeft = Math.max(0, Math.ceil(
    (new Date(trialExpiresAt).getTime() - Date.now()) / (1000 * 60 * 60 * 24)
  ));
  if (daysLeft > 7) return null;
  const isUrgent = daysLeft <= 2;
  return (
    <div className={`px-4 md:px-6 py-2.5 border-b ${
      isUrgent ? "bg-red-50 border-red-200 text-red-800" : "bg-amber-50 border-amber-200 text-amber-800"
    }`}>
      <div className="flex items-center justify-between gap-4">
        <p className="text-sm font-medium">
          Your {tier} trial
          {daysLeft === 0 ? " expires today!" : ` has ${daysLeft} day${daysLeft !== 1 ? "s" : ""} remaining.`}
        </p>
        <Link href={billingHref} className={`shrink-0 rounded-md px-3 py-1 text-xs font-semibold transition-colors ${
          isUrgent ? "bg-red-600 text-white hover:bg-red-700" : "bg-amber-100 text-amber-800 hover:bg-amber-200"
        }`}>
          Subscribe now
        </Link>
      </div>
    </div>
  );
}
